// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicator-details {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.indicators-objectlist {
    padding: 5px;
}

.indicators-objectlist > div {
    display: flex;
    justify-content: space-between;
}

.indicators-objectlist > div div {
    text-align: right;
}

.indicators-objectlist > div div * {
    margin-left: 5px
}

.indicators-additionallist {
    padding: 5px;
}

.indicators-additionallist div {
    display: flex;
    justify-content: space-between;
}

.indicators-additionallist div.indicators-additionallist-add {
    display: flex;
    justify-content: left;
}

.indicator-details-main {
    flex-grow: 1;
    flex-shrink: 0;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

/* text based tabs grow with their content (charts keep the fixed height), the window body scrolls */
.indicator-details-main.indicator-details-main-auto {
    height: auto;
    min-height: 300px;
    flex-grow: 0;
}

.indicator-details-wrapper .resizeable-window-body {
    padding: 0
}

.indicator-timedetails {
    margin: 1em;
    margin-top: 20px;
}

.indicator-details-main .timeslice-download-buttons {
    align-self: flex-end;
    margin: 1em;
    gap: 1em;
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./js/style/IndicatorDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA,oGAAoG;AACpG;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,QAAQ;IACR,aAAa;AACjB","sourcesContent":[".indicator-details {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n}\n\n.indicators-objectlist {\n    padding: 5px;\n}\n\n.indicators-objectlist > div {\n    display: flex;\n    justify-content: space-between;\n}\n\n.indicators-objectlist > div div {\n    text-align: right;\n}\n\n.indicators-objectlist > div div * {\n    margin-left: 5px\n}\n\n.indicators-additionallist {\n    padding: 5px;\n}\n\n.indicators-additionallist div {\n    display: flex;\n    justify-content: space-between;\n}\n\n.indicators-additionallist div.indicators-additionallist-add {\n    display: flex;\n    justify-content: left;\n}\n\n.indicator-details-main {\n    flex-grow: 1;\n    flex-shrink: 0;\n    height: 300px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n/* text based tabs grow with their content (charts keep the fixed height), the window body scrolls */\n.indicator-details-main.indicator-details-main-auto {\n    height: auto;\n    min-height: 300px;\n    flex-grow: 0;\n}\n\n.indicator-details-wrapper .resizeable-window-body {\n    padding: 0\n}\n\n.indicator-timedetails {\n    margin: 1em;\n    margin-top: 20px;\n}\n\n.indicator-details-main .timeslice-download-buttons {\n    align-self: flex-end;\n    margin: 1em;\n    gap: 1em;\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
